import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormArray, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-dynamic-field-render',
  templateUrl: './dynamic-field-render.component.html',
  styleUrls: ['./dynamic-field-render.component.scss']
})
export class DynamicFieldRenderComponent implements OnInit {

  @Input() schema: any[];
  @Input() form:any;
  @Input() parentGroup: any;

 @Output() addGroup = new EventEmitter<{ key: string; fields: any[]; parent: FormGroup }>();

 @Input() level = 0; // 0 = top level, 1+ = nested

  getFormArray(key: string, parent = this.parentGroup): FormArray {
    return parent.get(key) as FormArray;
  }

  constructor() { }

  ngOnInit(): void {
  }


removeGroup(fieldKey: string, index: number, parent: FormGroup) {
  if (confirm('Are you sure you want to remove ' + fieldKey + ' #' + (index + 1) + ' ?')) {


  const array = parent.get(fieldKey) as FormArray;
  if (array && array instanceof FormArray) {
    array.removeAt(index);
  }
}
}

}
